import React from 'react'
import { Link, useLocation } from 'react-router-dom'

const Footer: React.FC = () => {
  const location = useLocation()

  // Hide Footer on shared/public report pages (they have their own footer)
  if (location.pathname.startsWith('/shared/')) {
    return null
  }

  return (
    <footer className="bg-white border-t border-gray-200 py-4 text-center text-gray-500 text-sm mt-8">
      <div className="flex items-center justify-center gap-4">
        <span>
          &copy; {new Date().getFullYear()}{' '}
          <Link to="/" className="text-primary-700 hover:underline">
            Marzz AI
          </Link>
          . All rights reserved.
        </span>
        <span className="text-gray-300">|</span>
        <Link
          to="/metrics"
          className="text-gray-500 hover:text-primary-700 hover:underline transition-colors"
        >
          Metrics Reference
        </Link>
        <span className="text-gray-300">|</span>
        <Link
          to="/privacy"
          className="text-gray-500 hover:text-primary-700 hover:underline transition-colors"
        >
          Privacy
        </Link>
        <span className="text-gray-300">|</span>
        <Link
          to="/terms"
          className="text-gray-500 hover:text-primary-700 hover:underline transition-colors"
        >
          Terms
        </Link>
      </div>
    </footer>
  )
}

export default Footer
